import { getAllDocsByComment } from "@/api/comments/getAllDocsByComment";
import { IDocUploaded } from "@/api/comments/types";
import { useQueries } from "@tanstack/react-query";

export const useGetAllDocsByComment = (commentIds: string[]) => {
  const queries = useQueries({
    queries: commentIds.map((commentId) => ({
      queryKey: ["docsByComment", commentId],
      queryFn: () => getAllDocsByComment(commentId),
      staleTime: 1000 * 60 * 60,
      gcTime: 1000 * 60 * 30,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }))
  });

  const isLoading = queries.some(query => query.isLoading);
  const error = queries.find(query => query.error)?.error;

  const docsMap = queries.reduce((acc, query, index) => {
    acc[commentIds[index]] = (query.data?.data ?? []) as IDocUploaded[];
    return acc;
  }, {} as Record<string, IDocUploaded[]>);

  return {
    docs: (commentId: string) => docsMap[commentId],
    isLoading,
    error,
    refetch: async () => {
      await Promise.all(queries.map(query => query.refetch()));
    },
  };
};